const certificationStatusArr = ["Started", "Published", "In Progress"];
export const GetPublishedStatus = (projectData: { certification_status?: string | null }): string => {
	const status = projectData.certification_status;
	return typeof status === "string" && certificationStatusArr.includes(status) ? status : "Incomplete";
};
